export default "__VITE_ASSET__de641ef9__"